import { createApi } from '@reduxjs/toolkit/query/react';
import type {
    StartPageNewsForYouRequest,
    NewsForYouApiResponse
} from 'tradera/state/services/types/webapi-discover-generated';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import { isServer } from 'tradera/utils/nextjs';
import qs from 'qs';

const baseUrl = isServer ? '' : '/api/webapi';

export const wardrobeNewsForYouApi = createApi({
    reducerPath: 'wardrobeNewsForYouApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getWardrobeNewsForYou: builder.query<
            NewsForYouApiResponse,
            StartPageNewsForYouRequest
        >({
            query: (params) =>
                `${baseUrl}/discover/web/start-page/news-for-you?${qs.stringify(params)}`
        })
    })
});

export const { useGetWardrobeNewsForYouQuery } = wardrobeNewsForYouApi;
